import React from "react";
import { Heart } from "@phosphor-icons/react";
import { useWishlist } from "../hooks/useWishlist";

export default function WishlistHeart({ kind, itemId, size = 20, className = "" }) {
  const { has, toggle } = useWishlist();
  const isFav = has(kind, itemId);

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(kind, itemId);
      }}
      aria-label={isFav ? "Remove from wishlist" : "Add to wishlist"}
      data-testid={`wishlist-heart-${kind}-${itemId}`}
      className={`w-9 h-9 rounded-full flex items-center justify-center bg-white/95 backdrop-blur shadow hover:scale-110 transition-transform ${className}`}
    >
      <Heart
        size={size}
        weight={isFav ? "fill" : "regular"}
        className={isFav ? "text-red-500" : "text-midnight"}
      />
    </button>
  );
}
